/**
 * @fileoverview GET handler for the "/engagement/campaigns_for_uco" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementCampaignsForUco } from "./constants";
import type { CampaignsForUcoResult } from "./types";
import { isCampaignsForUcoResult } from "./validators";

export const getCampaignsForUco = reactQueryFetcherAdapter(
  engagementCampaignsForUco,
  (signal: AbortSignal): Promise<CampaignsForUcoResult> => {
    return fetch("/engagement/campaigns_for_uco", "GET", {}, { signal });
  },
  isCampaignsForUcoResult
);
